import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function PainSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-cream relative" data-id="element-275">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-277">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-278">
            {t('pain.title')}
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-279"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="prose prose-lg prose-brand mx-auto text-brand-charcoal space-y-6" data-id="element-280">
          <p className="text-xl font-medium text-center mb-8" data-id="element-281">{t('pain.p1')}</p>

          <p data-id="element-282">{t('pain.p2')}</p>

          <p data-id="element-283">{t('pain.p3')}</p>

          <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 my-10" data-id="element-284">
            <p className="italic text-brand-brown" data-id="element-285">{t('pain.quote')}</p>
          </div>

          <p className="font-semibold text-xl text-brand-brown mt-12" data-id="element-286">
            {t('pain.truth')}
          </p>

          <p className="text-2xl font-serif text-brand-gold-light text-center my-8" data-id="element-287">
            {t('pain.highlight')}
          </p>

          <p data-id="element-288">{t('pain.p4')}</p>

          <p className="text-xl font-medium text-center mt-8" data-id="element-289">{t('pain.p5')}</p>
        </motion.div>
      </div>
    </section>;
}